<div class="m-1 {{ classes() }}" [class.invalid]="isInvalid()">
    @if (AdaaHelper.isDefinedAndNotEmpty(label())) {
        <label [for]="effectiveControlId()" class="form-label"
            >{{ label() }}
            @if (isRequired()) {
                <span class="form-required text-danger fw-bolder">*</span>
            }
        </label>
    }
    <div class="mb-2" ngbDropdown #ddl="ngbDropdown" container="body">
        <button
            type="button"
            class="dropdown-button text-truncate"
            #btn
            [id]="effectiveControlId()"
            ngbDropdownToggle
            [disabled]="effectivelyDisabled()"
            [class.border]="isInvalid()"
            [class.border-danger]="isInvalid()"
            [class.ae]="AdaaHelper.getCurrentLang() === Language.Arabic"
        >
            @if (isMultiple()) {
                {{ selectedValue.length }} {{ "common.ddl_items_selected" | translate }}
            } @else {
                {{ selectedObjects && selectedObjects.length > 0 ? selectedObjects[0].text : "" }}
            }
        </button>
        <div ngbDropdownMenu [matchWidth]="btn">
            <input
                class="form-control shadow-sm"
                [placeholder]="'common.form.label.search' | translate"
                #searchInput
                (keyup)="search(searchInput.value)"
            />
            <ul class="tree-ddl">
                @for (item of displayOptions; track item) {
                    <adaa-form-dropdown-tree-node
                        [isMultiple]="isMultiple()"
                        [option]="item"
                        [selectedValue]="selectedValue"
                        [hasSearch]="hasSearch"
                        (valueSelected)="valueChanged($event)"
                    />
                }
            </ul>
        </div>
    </div>
    @if (isMultiple()) {
        @for (item of selectedObjects; track item) {
            <div class="alert alert-primary mb-2">
                {{ item.text }}
                @if (!effectivelyDisabled()) {
                    <button type="button" class="btn-close float-end" (click)="removeSelection(item.value)"></button>
                }
            </div>
        }
    }
</div>
